<div class="{containerClass} {position}">
</div>

<script  context="module">export const containerClass = 'paper-toast-container';
</script>

<script >;
export let position = 'top-right';
</script>

<style >:global(.paper-toast-container:is(.top, .bottom) > div) {
  align-self: center;
}

:global(.paper-toast-container:is([class*=right]) > div) {
  align-self: end;
}

div {
  height: 0;
  position: fixed;
  display: flex;
  width: 100%;
  padding: 2em;
  z-index: 9999;
  flex-direction: column;
}
div[class*=top] {
  top: 0;
}
div[class*=bottom] {
  bottom: 0;
  flex-direction: column-reverse;
}
div[class*=left] {
  left: 0;
}</style>
